<template>
  <div class="osk-wrapper vertical-paddings">
    <h2 class="section-title text-center mb-4">
      {{ $t('components.info.pressPage.title') }}
    </h2>

    <div class="section-subtitle text-center subtitle">
      {{ $t('components.info.pressPage.subtitle') }}
    </div>

    <div class="press_about_blocks">
      <div
        v-for="article in articles"
        :key="article.link"
        class="block"
      >
        <div
          :class="article.imageClass"
          class="left_logo"
        >
          <img
            :src="article.image"
            alt="logo"
          >
        </div>
        <div class="right_info_text">
          <div class="name_block">
            {{ article.title }}
          </div>

          <p v-if="article.description">
            {{ article.description }}
          </p>

          <div class="data_block">
            {{ article.date }}
          </div>

          <div class="a_link">
            <a
              :href="article.link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>{{ $t('components.info.pressPage.read') }}</span>

              <svg
                width="30"
                height="49"
                viewBox="0 0 30 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 2L27 24.5L2 47"
                  stroke="#333333"
                  stroke-width="4"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { filename } from 'pathe/utils';

const glob: Record<string, { default: string }> = import.meta.glob('~/assets/img/press/*.svg', { eager: true });
const images = Object.fromEntries(
  Object.entries(glob).map(([ key, value ]) => [ filename(key), value.default ]),
);

useHead({
  title: 'Пресса о нас – Интернет-магазин Oskelly',
  meta: [
    {
      name: 'description',
      content: 'Пресса о нас – Интернет-магазин Oskelly',
    },
  ],
});

const { t } = useI18n();

const articles = [
  {
    title: t('components.info.pressPage.article1.title'),
    description: t('components.info.pressPage.article1.description'),
    date: t('components.info.pressPage.article1.date'),
    link: 'https://www.cosmo.ru/fashion/how_to/vazhnyy-vopros-na-chto-obratit-vnimanie-pri-pokupke-b-u-veshchi/',
    image: images.cosmopolitan,
    imageClass: 'cosmopolitan_logo',
  },
  {
    title: t('components.info.pressPage.article2.title'),
    description: '',
    date: t('components.info.pressPage.article2.date'),
    link: 'https://vc.ru/trade/66518-startap-dnya-rossiyskiy-marketpleys-poderzhannoy-brendovoy-odezhdy-oskelly',
    image: images.vc,
    imageClass: 'vc_logo',
  },
  {
    title: t('components.info.pressPage.article3.title'),
    description: '',
    date: t('components.info.pressPage.article3.date'),
    link: 'http://www.sncmedia.ru/fashion/lyuksovye-veshchi-kak-investitsii-vo-chto-vkladyvat/?fbclid=IwAR3h4L_e2LyY2A8rFuE0ARxZXNP_T-Y6q4F0H-k06gQjXEN00pJemlifO40',
    image: images.snc,
    imageClass: 'snc_logo',
  },
  {
    title: t('components.info.pressPage.article4.title'),
    description: '',
    date: t('components.info.pressPage.article4.date'),
    link: 'https://kp.vedomosti.ru/deluxe/article/2019/03/28/797663-poddelki-i-modnie-doma-vred-i-polza',
    image: images.vedomosti,
    imageClass: 'vedomosti_logo',
  },
];
</script>

<style scoped lang="scss">
.vertical-paddings {
  padding-top: 70px;
  padding-bottom: 100px;
}

.subtitle {
  max-width: 520px;
  margin: 0 auto;
}

.press_about_blocks {
  margin-top: 40px;
}

.press_about_blocks .block {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 40px 100px 40px 0;
  margin-bottom: 41px;
  align-items: center;
}

.press_about_blocks .block:last-child {
  margin-bottom: 0;
}

.press_about_blocks .block .left_logo {
  width: 315px;
  box-sizing: border-box;
  height: 114px;
  border-right: 1px solid #F2F2F2;
  position: relative;
}

.press_about_blocks .block .left_logo img,
.press_about_blocks .block .left_logo svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.press_about_blocks .block .right_info_text {
  width: calc(100% - 315px);
  max-width: 790px;
  box-sizing: border-box;
  padding-left: 43px;
}

.press_about_blocks .block .right_info_text .name_block {
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
}

.press_about_blocks .block .right_info_text p {
  font-size: 14px;
  line-height: 21px;
  color: #828282;
  margin-top: 8px;
}

.press_about_blocks .block .right_info_text .data_block {
  color: #828282;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 18px;
}

.press_about_blocks .block .right_info_text .a_link {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.press_about_blocks .block .right_info_text .a_link a {
  display: block;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(189, 189, 189, 0.6);
  border-radius: 2px;
  transition: all 0.3s ease;
}

.press_about_blocks .block .right_info_text .a_link a span {
  display: none;
}

.press_about_blocks .block .right_info_text .a_link a svg {
  position: absolute;
  top: 50%;
  right: 45px;
  transform: translate(0, -50%);
  opacity: .05;
  transition: all 0.3s ease;
}

.press_about_blocks .block .right_info_text .a_link a:hover {
  border: 1px solid #333333;
}

.press_about_blocks .block .right_info_text .a_link a:hover svg {
  opacity: 1;
}

@media only screen and (max-width: 1024px) {
  .press_about_blocks .block {
    display: block;
    padding: 0px 80px 30px 22px;
    margin-bottom: 31px;
  }

  .press_about_blocks .block .left_logo {
    width: 100%;
    border-right: none;
    position: relative;
    height: 110px;
  }

  .press_about_blocks .block .left_logo img,
  .press_about_blocks .block .left_logo svg {
    left: 0;
    top: 30px;
    transform: translate(0, 0);
  }

  .press_about_blocks .block .cosmopolitan_logo img {
    width: 168px;
  }

  .press_about_blocks .block .vc_logo img {
    width: 128px;
  }

  .press_about_blocks .block .snc_logo img {
    width: 107px;
  }

  .press_about_blocks .block .vedomosti_logo img {
    width: 157px;
  }

  .press_about_blocks .block .right_info_text {
    width: 100%;
    padding: 0;
  }

  .press_about_blocks .block .right_info_text .a_link a svg {
    right: 25px;
  }
}

@media only screen and (max-width: 767px) {
  .press_about_blocks .block {
    padding: 0px 12px 18px;
    border: 1px solid rgba(189, 189, 189, 0.6);
    border-radius: 2px;
  }

  .press_about_blocks .block .left_logo {
    height: 94px;
  }

  .press_about_blocks .block .cosmopolitan_logo img {
    width: 146px;
  }

  .press_about_blocks .block .vc_logo img {
    width: 112px;
  }

  .press_about_blocks .block .snc_logo img {
    width: 94px;
  }

  .press_about_blocks .block .vedomosti_logo img {
    width: 136px;
  }

  .press_about_blocks .block .right_info_text p {
    font-size: 12px;
    line-height: 18px;
  }

  .press_about_blocks .block .right_info_text .name_block {
    font-size: 16px;
    line-height: 22px;
  }

  .press_about_blocks .block .right_info_text .data_block {
    margin-top: 15px;
  }

  .press_about_blocks .block .right_info_text .a_link {
    position: static;
    margin-top: 35px;
  }

  .press_about_blocks .block .right_info_text .a_link a {
    border: 1px solid #202020;
    font-size: 14px;
    line-height: 46px;
    box-sizing: border-box;
  }

  .press_about_blocks .block .right_info_text .a_link a span {
    display: block;
    text-align: center;
  }

  .press_about_blocks .block .right_info_text .a_link a svg {
    display: none;
  }

  .press_about_blocks .block .right_info_text .a_link a:hover {
    color: #ffffff;
    background: #202020;
  }
}
</style>
